import React from 'react';
import { Award } from 'lucide-react';

const AchievementsSection = ({ data }) => {
  return (
    <section id="achievements" className="achievements-section">
      <div className="section-container">
        <div className="achievements-grid">
          <div className="achievements-content">
            <div className="section-label">Track Record</div>
            <h2 className="section-heading">{data.title}</h2>
            
            <div className="achievements-list">
              {data.items.map((item, index) => (
                <div key={index} className="achievement-item">
                  <div className="achievement-icon-wrapper">
                    <Award size={24} className="achievement-icon" />
                  </div>
                  <div className="achievement-content">
                    <h3 className="achievement-title">{item.title}</h3>
                    <p className="achievement-description">{item.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="achievements-image-wrapper">
            <img 
              src={data.image} 
              alt="Dr. Subhashini G receiving award"
              className="achievements-image"
            />
            <div className="achievements-badge">
              <Award size={32} />
              <span>National Recognition</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AchievementsSection;
